import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_URL = "https://icb5sfzit9.execute-api.us-east-1.amazonaws.com/document";
const API_KEY = "154122054";

const headers = {
  "x-api-key": API_KEY,
  "Content-Type": "application/json",
};

const ViewPDFs = () => {
  const { id } = useParams(); // Get PDF ID from the URL
  const [pdfUrl, setPdfUrl] = useState(null);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const response = await axios.get(API_URL, { headers });

        // The response is an array. Find the item that matches the given ID.
        const pdfData = response.data.find((item) => item.id === id);

        if (pdfData) {
          setPdfUrl(pdfData.s3Url);
          setTitle(pdfData.title);
        } else {
          console.error("PDF not found for the given ID");
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching PDFs:", error);
        setLoading(false);
      }
    };

    fetchPdf();
  }, [id]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 text-white mb-4">
      {loading ? (
        <div className="flex justify-center items-center min-h-[50vh]">
          <div className="w-16 h-16 border-4 border-t-red-500 border-b-transparent border-r-transparent border-l-blue-500 rounded-full animate-spin"></div>
        </div>
      ) : pdfUrl ? (
        <>
          <h2 className="text-xl md:text-2xl font-semibold text-center mb-4 text-white">
            {title}
          </h2>
          <iframe
            src={pdfUrl}
            className="w-full max-w-4xl h-[90vh] border-2 border-white rounded-lg"
            title={title}
          ></iframe>
        </>
      ) : (
        <p className="text-red-500">PDF not found</p>
      )}
    </div>
  );
};

export default ViewPDFs;
